import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/management/icn_management_04.png';
import icn_02 from '../../assets/img/landingPage/devStudio/dev-s_03_brunix.svg';
import icn_03 from '../../assets/img/landingPage/platon_foundation/TPF_vision.svg';
import icn_04 from '../../assets/img/landingPage/designer/icn_Desginer-02.png';
import icn_05 from '../../assets/img/landingPage/designer/icn_Designer-03.png';
import icn_06 from '../../assets/img/landingPage/collab/CN_03_security.svg';

import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/public/public-dashboard.png';


const PublicSector = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'Modernize Legacy Infrastructure',
            text: "Connect aging systems to new applications through AVAP’s virtual APIs and connectors, without rewriting core systems.",
            altDescription: "Key Feature 01",
            image: product_gateway,
        },
        Key_Feature_02: {
            title: "Deliver Better Citizen Services",
            text: "Build secure, scalable digital experiences across web, mobile, and physical service points, without duplicating efforts.",
            altDescription: "Build secure, scalable digital experiences across web, mobile, and physical service points, without duplicating efforts.",
            image: product_gateway,
        },
        Key_Feature_03: {
            title: 'Automate Government Workflows',
            text: 
            "Streamline permitting, licensing, record-keeping, and case processing with reusable logic and AI-powered orchestration.",
            altDescription: 'Streamline permitting, licensing, record-keeping, and case processing with reusable logic and AI-powered orchestration.',
            image: product_gateway,
        },
        Key_Feature_04: {
            title: 'Enhance Transparency & Compliance',
            text: 
            "Track data flows, enforce access policies, and ensure audit-readiness with built-in governance, security, and version control.",
            altDescription: 'Track data flows, enforce access policies, and ensure audit-readiness with built-in governance, security, and version control.',
            image: product_gateway,
        },
        Key_Feature_05: {
            title: 'Boost Inter-Agency Collaboration',
            text: 
            "Standardize how departments exchange information through controlled, governed APIs that support shared services and open data initiatives.",
            altDescription: 'Standardize how departments exchange information through controlled, governed APIs that support shared services and open data initiatives.',
            image: product_gateway,
        },
    }
    
    //Key Benefits Bento
    const items = [
        {
          icon: icn_01,
          title: 'Virtual-first architecture',
          paragraphs: [
            'Simulate and deploy APIs without affecting production systems.',
          ],
        
        },
        {
          icon: icn_02,
          title: 'AI-powered process optimization',
          paragraphs: [
            'Use Gen-AI to automate logic, reduce redundancies, and speed up service delivery',
          ]
        },

        {
          icon: icn_03,
          title: 'Built-in observability and audit tools',
          paragraphs: [
            'Monitor and track every interaction.',
          ]
        },
        {
          icon: icn_04,
          title: 'Low-code, modular design',
          paragraphs: [
            'Empower more teams to participate in digital transformation.'
          ]
        },
        {
          icon: icn_05,
          title: '100% API-exposed functionality',
          paragraphs: [
            'Integrate AVAP into existing portals, service layers, and security systems.',
          ]
        },
        {
            icon: icn_06,
            title: 'Policy-aligned by design',
            paragraphs: [
              'Configure workflows and data flows to meet local regulations, privacy laws, and compliance standards.',
            ]
          },
      ];
      
    const breakpointColumnsObj = {
        default: 3, //Cambio de columnas verticales
        1100: 2,
        700: 1
      
    };

    //Bento - benefits cajas
    const items2 = [
        {
          icon: icn_01,
          title: 'Modernize Legacy Infrastructure',
          paragraphs: [
            'Connect aging systems to new applications through AVAP’s virtual APIs and connectors, without rewriting core systems.',
          ],
        
        },
        {
          icon: icn_02,
          title: 'Deliver Better Citizen Services',
          paragraphs: [
            'Build secure, scalable digital experiences across web, mobile, and physical service points, without duplicating efforts.',
          ]
        },

        {
          icon: icn_03,
          title: 'Automate Government Workflows',
          paragraphs: [
            'Streamline permitting, licensing, record-keeping, and case processing with reusable logic and AI-powered orchestration.',
          ]
        },
        {
          icon: icn_04,
          title: 'Enhance Transparency & Compliance',
          paragraphs: [
            'Track data flows, enforce access policies, and ensure audit-readiness with built-in governance, security, and version control.'
          ]
        },
        {
          icon: icn_05,
          title: 'Boost Inter-Agency Collaboration',
          paragraphs: [
            'Standardize how departments exchange information through controlled, governed APIs that support shared services and open data initiatives.',
          ]
        },
      ];
      
    const breakpointColumnsObj2 = {
        default: 3, //Cambio de columnas verticales
        1100: 2,
        700: 1
      
    };

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center py-5">

                    <h1 className="fl-title-big m-0">AVAP for the Public Sector</h1>
                    <p className="fl-title m-0 gradient-text">Modernize public services. Automate workflows. <br />
                    Deliver citizen-first digital experiences</p>
                            
              </section>

        

                {/* Subtítulo descripción */}
                <section className="text-center pb-5">
                   <img
                        src={dashboard}
                        className="img-fluid mt-0"
                        style={{ width: '80%', maxWidth: '900px', height: 'auto' }}
                    />
                    <p className="fl-text fl-txt-container-s pt-8" >
                        With AVAP Framework, government agencies and public institutions can modernize their systems, unify data, and expose services securely,  all through modular, reusable APIs. Unlock real-time visibility, accelerate project delivery, and simplify compliance with an API-first approach built for scale and trust.
                    </p>
                     {/*Boton Contact Us*/}  
                     <a className="glowBtn-dark mb-4 " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>
                    
                 <div className="fl-card-border container text-center p-5">
                    <h2 className="fl-title mt-0 py-5 gradient-text fl-title m-4">Why AVAP for the Public Sector?</h2>

                    <p className="fl-text fl-txt-container-s">Government agencies and public institutions face complex challenges: legacy infrastructure, siloed systems, growing security needs, and pressure to deliver better citizen services. AVAP Framework empowers you to meet these demands with flexibility and speed.
                    </p><br/>

                    {/* Sección Bullets */}
                    <ul className="fl-bullets fl-text text-center fl-txt-container-s">
                    <li className="fl-bullets">Digitize public services with reusable, compliant APIs.</li>
                    <li className="fl-bullets">Modernize legacy systems without costly overhauls.</li>
                    <li className="fl-bullets">Enable secure, omnichannel citizen engagement.</li>
                    <li className="fl-bullets">Automate inter-agency processes with Gen-AI and low-code tools.</li>
                    <li className="fl-bullets">Ensure transparency and traceability with full governance.</li> </ul>
                </div>

                   {/* <h2 className="fl-title m-0 gradient-text fl-title m-4">Connect everything. Empower everyone.</h2>
                    <p className="fl-text text-center fl-txt-container-s">
                    AVAP Integration unifies the power of automation, data flow, and intelligent orchestration. With native virtualization and AI assistance, AVAP Framework helps developers and business teams integrate applications, services, and data sources — across clouds, on-premises systems, and legacy architectures — without friction. Free your teams from bottlenecks and legacy dependencies with a platform that adapts to change, scales effortlessly, and delivers real-time integration insights.
                    </p>*/}

                </section>

                {/* Sección Key Features */}
                {/*<div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                            <h3 className="fl-title text-center">Our Products & Services</h3>
                            <br />
                            &nbsp;
                            <br />&nbsp;
                            <p className="fl-title-center m-0">Key Capabilities</p>
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-6">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>*/}

                {/* Sección Key Features Bento */}
                
                <div className="container pt-8">
                <div className="fl-title text-center mb-5">
                Key Capabilities
                    </div>
                    <Masonry
                    breakpointCols={breakpointColumnsObj2}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items2.map((item, idx) => (
                        <div key={idx} className="fl-card-s text-center grayGradient">
                        {/*<img src={item.icon} alt="Icon representing 0X" className="solutionsIcon" />*/}
                        <p className="fl-subtitle-xs">{item.title}</p>
                        {item.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>

                <div className="fl-card-border container text-center">
                    <h2 style={{ marginTop: '40px' }} className="fl-title mt-0 pb-5 gradient-text fl-title m-4">A Phased Journey to Public Sector Modernization with AVAP</h2>

                    <p className="fl-text fl-txt-container-s">Modernizing public services requires more than digital tools, it demands a structured, strategic approach that balances innovation with compliance, integration with legacy systems, and citizen experience with operational efficiency. 

                    </p><br/>
                    
                    <p className="fl-text fl-txt-container-s">AVAP Framework supports this evolution through five progressive phases, each unlocking new levels of agility, visibility, and service quality.
                    
                    {/*<img
                        src={dashboard}
                        className="img-fluid mt-4"
                        style={{ width: '70%', maxWidth: '800px', height: 'auto' }}
                    />*/}
                    </p><br/>
                    
                </div>

                {/* Sección Built */} 
                {/*<section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                                <div className="blob"></div>
    

                                <div className="rightBC">
                                    <h3 className='fl-title'>Built for modern teams</h3>
                                    <p>AVAP Integration empowers both IT and business users with no-code/low-code tools and reusable virtual connectors for:
                                    </p>*/} 
                                    {/* Sección Bullets */}
                                   {/* <ul className="fl-bullets fl-text  .fl-txt-container-s " >
                                    <li className="fl-bullets">Cloud & SaaS platforms</li>
                                    <li className="fl-bullets">On-prem legacy systems</li>
                                    <li className="fl-bullets">Databases & messaging systems</li>
                                    <li className="fl-bullets">Internal and third-party APIs</li>
                                    </ul>
                                    <p>Break data silos and give teams the freedom to build connected workflows across any system.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>*/}

                {/*MASONRY 2 COLUMNAS, ICONO CENTRADO, FONDO GRIS, TITULO Y PÁRRAFO */}
                <div className="container pt-8">
                <div className="fl-title text-center mb-5">
                What Makes AVAP Different?
                    </div>
                    <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items.map((item, idx) => (
                        <div key={idx} className="fl-card-s text-center grayBox">
                        <img src={item.icon} alt="Icon representing 0X" className="solutionsIcon" />
                        <p className="fl-subtitle-xs">{item.title}</p>
                        {item.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>

                {/* Sección Key Benefits */}   
               {/* <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col  mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                
                                <p className="fl-subtitle-xs">
                                Unify your data
                                </p>
                                <p className="fl-text">
                                Create a single source of truth by linking all your systems, regardless of format or source.

                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Accelerate delivery
                                </p>
                                <p className="fl-text">
                                Start faster with AI-assisted configuration, smart templates, and reusable integration assets.
                                    <br />&nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Make integration intelligent
                                </p>
                                <p className="fl-text">
                                Predict bottlenecks, monitor flows, and auto-tune performance with AVAP’s Gen-AI engine.

                                </p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Protect every connection
                                </p>
                                <p className="fl-text">
                                Enforce policies across all connections with dynamic authentication, rate limiting, and encryption — built in.

                                </p>
                            </div>
                        </div>
                        
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Measure and improve
                                </p>
                                <p className="fl-text">
                                Track integration KPIs in real time with built-in analytics and smart dashboards.

                                </p>
                            </div>
                        </div>

                    </div>
                </section>*/} 

                {/*Boton Contact Us*/}  
                <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>


                {/* Sección built for secure */} 
                {/*<section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                                <div className="blob"></div>
    

                                <div className="rightBC">
                                    <h3 className='fl-title'>Designed for your architecture</h3>
                                    <p>Whether you're operating in the cloud, on-prem, or in hybrid environments, AVAP Framework adapts seamlessly to your infrastructure and governance model.

                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>*/}

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default PublicSector;
